/**
 * @generated SignedSource<<9c8b71b8c19eec178ae3815c6728c9e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableContainer_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespRefetchableSimilarItemsGrid_user" | "PdpRespSharedHeroCarousel_user" | "PdpRespSharedPrintDetailsLazy_user" | "PdpRespSharedSidebarSellerInfoAndContact_user" | "PdpRespUnavailableDetailsTabs_user" | "PdpSharedFeaturedRelatedItemsCarouselLazy_user" | "PdpSharedItemFavorites_user" | "PdpSharedSellerItemsCarousel_user">;
  readonly " $fragmentType": "PdpRespUnavailableContainer_user";
};
export type PdpRespUnavailableContainer_user$key = {
  readonly " $data"?: PdpRespUnavailableContainer_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableContainer_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "afterDisplayAndNotBot"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableContainer_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespUnavailableDetailsTabs_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedHeroCarousel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedPrintDetailsLazy_user"
    },
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedItemFavorites_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSharedSidebarSellerInfoAndContact_user"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerItemsCarousel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespRefetchableSimilarItemsGrid_user"
    },
    {
      "condition": "afterDisplayAndNotBot",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedFeaturedRelatedItemsCarouselLazy_user"
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "472a58ad19494babbffe56a74b49b34f";

export default node;
